import { useRef } from "react"
import { Verihub } from "./Verihub.js";
import "./App.css";

function App(){
  const vVideoTag = useRef( null );
  const vCanvas1 = useRef( null );
  const vCanvas2 = useRef( null );
  const vCanvas3 = useRef( null );

  const fDrawFace = (
    vCanvasElement
    , vFaceData
    , vExtraCanvas
  ) => {
    const vEvent = new Event(
      "next_frame"
      ,
        {
          "bubbles": true
          , "cancelable": false
        }
    );
    document.dispatchEvent( vEvent );
    alert( JSON.stringify( vFaceData.matches ) );
    let vBox = vFaceData.result[ 0 ].box;
    vCanvasElement.clearRect( 0, 0, 640, 480 );
    vExtraCanvas.clearRect( 0, 0, 640, 480 );

    vCanvasElement.strokeStyle = "green";
    vExtraCanvas.strokeStyle = "blue";
    vExtraCanvas.fillStyle = "white"

    vExtraCanvas.lineWidth = 5;
    vCanvasElement.lineWidth = 5;
    
    vCanvasElement.strokeRect(
      vBox.x_min
      , vBox.y_min
      , vBox.x_max - vBox.x_min
      , vBox.y_max - vBox.y_min
    );

    vExtraCanvas.fillText(
        Number.parseFloat( vBox.probability ).toPrecision( 5 )
        + '  '
        + vFaceData.result[ 0 ].subjects[ 0 ].subject
        + '  '
        + vFaceData.result[ 0 ].subjects[ 0 ].similarity
      , vBox.x_min
      , vBox.y_min - 10
    )
  }
  
  const fHandleVideoStart = () => {
    navigator.mediaDevices.getUserMedia(
      {
        video: true
      }
    )
    .then(
      vStream => {
        vVideoTag.current.srcObject = vStream
      }
    )
    .catch(
      vError => {
        console.error( vError )
      }
    )

    vVideoTag.current.addEventListener(
      "play"
      ,
        () => {
          let vAppId = "3ef63acc-6940-4044-80fd-d1c281cab75e";
          let vAPIKey = "LJ8W65c5nMSTziSa2urUwgQnw7rJkTQR";
    
          let vVerihub = new Verihub( vAppId, vAPIKey );
    
          let vCanvas1Content2d = vCanvas1.current.getContext( "2d" );
          let vCanvas2Content2d = vCanvas2.current.getContext( "2d" );
          let vCanvas3Content2d = vCanvas3.current.getContext( "2d" );

          document.addEventListener(
            "next_frame"
            , () => {
              vCanvas1Content2d.drawImage(
                vVideoTag.current
                , 0
                , 0
                , 640
                , 480
              );
              vVerihub.FaceSearch(
                vCanvas1.current.toDataURL("image/jpeg").split(';base64,')[1]
              )
              .then(
                vResponse => {
                  fDrawFace(
                    vCanvas2Content2d
                    , vResponse
                    , vCanvas3Content2d
                  )
                }
              );
            }
          )

          const vEvent = new Event(
            "next_frame"
            , {
              "bubbles": true
              , "cancelable": false
            }
          );

  			  document.dispatchEvent( vEvent );
        }
    )
  } 

  return (
    <div className="App">
      <header className="App-header">
        <video ref={vVideoTag} width="640" height="480" autoPlay muted ></video>
        <canvas ref={vCanvas1} width="640" id="canvas" height="480" style={{ display: 'none' }}></canvas>
	      <canvas ref={vCanvas2} width="640" id="canvas2" height="480" style={{ position: 'absolute' }} ></canvas>
        <canvas ref={vCanvas3} width="640" height="480" style={{ position: 'absolute' }}></canvas>
        <div>
          <button onClick={fHandleVideoStart} >Start video</button>
        </div>
      </header>
    </div>
  );
}

export default App;